<template>
  <div
    class="table-saved-filters f-column"
    style="min-height: 0; max-width: 100vw; max-height: 100vh; overflow: hidden"
  >
    <div class="f-align-center w-100 no-scroll-track">
      <div class="text-large my-auto f-center weight_700 text-nowrap">
        {{ $t('common.choose_rake') }}
      </div>

      <LinkGuide
        class="ml-auto"
        :link="links_url_links.rakes_guide.url"
        :text="links_url_links.rakes_guide.text"
        @click.stop
      />
    </div>

    <div
      class="f-column mh-0"
      style="min-width: clamp(1px, 52rem, calc(100vw - 4rem))"
    >
      <div
        v-if="rake_call.error"
        class="gw_box mt-4"
        style="background: var(--clr-black-0-3)"
      >
        <IconAndText
          icon="mdi-alert-circle-outline"
          class="pa-8"
          style="--icon-size: 5rem; --icon-color: var(--clr-error)"
          :title="$t('messages.oops_error')"
          :subtitle="$t('messages.opps_error_sub')"
        >
        </IconAndText>
      </div>

      <div
        v-else
        class="f-column mt-2 wh-0 scroll-bottom-overlaya position-relative"
        :class="{ 'gw_loading no-events': rake_call.loading }"
        style="
          overflow: hidden;
          flex: 1 1 auto;
          max-height: 100%;
          --clr-scrl-back: var(--clr-black-1);
          --scrl-height: 1rem;
          --scrlb-inset: auto auto -1px 0;
        "
      >
        <div
          class="d-flex f-column flex-1 no-scroll-track"
          style="overflow-y: auto; overflow-x: hidden; gap: 0.75rem; padding: 0 0 0rem 0"
        >
          <!-- v-for="(table, idx) in [siteTables[0]]" -->
          <ExpandCard
            v-for="(table, idx) in siteTables"
            :key="idx"
            :opened="false"
            style="
              --radius-open: 8px;
              --radius-closed: 8px;
              --max-height: calc(100vh - 15rem);
              --clr-back-content: var(--clr-black-0-3);
              --content-paddings: 0.5rem;
              --content-display: flex;
            "
            :scrollViewProps="{
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            }"
            class="gw_loading_text"
            :data-tst="`cardexpand_${table.site}`"
          >
            <template #title>
              <GwSiteItem
                v-if="!rake_call.error && rake_call.loaded"
                :siteId="table.site"
              />
            </template>

            <RakesTable
              v-if="!rake_call.error && rake_call.loaded"
              :items="table.items"
              :tstPrefix="table.site"
              @click:item="({ item }) => $emit('click:item', { item })"
            />
          </ExpandCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import table_mix from '@/components/DataTables/table_mix'
import fetch_mix from '@/mixins/fetch_mix'
import RakesTable from '@/components/DataTables/v2/tables/RakesTable/RakesTable'
import links_mix from '@/mixins/links_mix'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import GwSiteItem from '@/components/DataTables/Filters/new/items/GwSiteItem'
import LinkGuide from '@/components/AppBar/LinkGuide'
import IconAndText from '@/components/Poker/Overlays/IconAndText'

export default {
  name: 'RakesTables',
  components: {
    RakesTable,
    ExpandCard,
    GwSiteItem,
    LinkGuide,
    IconAndText,
  },
  mixins: [table_mix, fetch_mix, links_mix],
  props: {},
  emits: ['click:item'],
  data() {
    return {
      rake_call: {
        conf: {
          endpoint: 'poker/rakes/',
          apiVersion: 'v1',
          params: { cache_change: 2 },
        },
        loading: false,
        loaded: false,
        status: 0,
      },

      siteTables: [...new Array(11).keys()],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const { data, error } = await this.fch_getData(this.rake_call)
      if (error) {
        return
      }
      const allItems = (data || []).reduce((acc, site) => {
        const items = site.properties.reduce((accSite, property) => {
          const rakes = property.rakes.map(rake => ({
            id: uuid(),
            item: rake,
            site: site.name,
            type: property.name,
            stake: rake.stake,
            rakeCap: Number(rake.cap_in_chips),
            rakePercent: Number(rake.pct_of_pot),
            preflopRakeType: rake.preflop_rake_type,
            // this.$t(`solfigr.rake.${id}`)
          }))
          return [...accSite, ...rakes]
        }, [])
        acc = [...acc, ...items]
        return acc
      }, [])

      const sites = [...new Set(allItems.map(item => item.site))].sort()
      this.siteTables = sites.map(site => ({
        site,
        items: allItems.filter(item => item.site === site),
      }))
      // this.allItems = allItems
    },
  },
}
</script>
